import PlannerListComponent from '../../components/planners-list/PlannerListComponent'
import { useEffect, useState } from 'react'
import styles from './plannersListPage.module.scss'
import { getPlanners, addPlannerToKazoo } from '../../features/plannerSlice'
import { useDispatch, useSelector } from 'react-redux'
import CommonModal from '../../components/atoms/modal/CommonModal'
import WeddingSelect from '../vendors-list/Modals/WeddingSelect'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import { closeModal, setModalData } from '../../features/commonSlice'
import { Typography } from '@mui/material'
import { useTutorial } from '../../context/TutorialContext'
import { useTutorialStatus } from '../../hooks/useTutorialStatus'

export default function PlannersListPage() {
	const dispatch = useDispatch()
	const plannerFilters = useSelector((state) => state.planner.plannerFilters)
	const modal = useSelector((state) => state.common.modal)
	const modalData = useSelector((state) => state.common.data)
	const [selectedKazoo, setSelectedKazoo] = useState(null)

	useEffect(() => {
		dispatch(getPlanners({ ...plannerFilters, withRatings: true }))
	}, [dispatch, plannerFilters])

	const tutorialId = 'planners-list'

	const { hasSeenTutorial, isLoading } = useTutorialStatus(tutorialId)
	const { startTutorial, isTutorialActive } = useTutorial()

	useEffect(() => {
		if (tutorialId && !isLoading && !hasSeenTutorial && !isTutorialActive()) {
			const timer = setTimeout(() => {
				startTutorial(tutorialId)
			}, 1000)

			return () => clearTimeout(timer)
		}
	}, [
		tutorialId,
		isLoading,
		hasSeenTutorial,
		isTutorialActive,
		startTutorial,
	])

	const closeAllModals = () => {
		dispatch(closeModal())
		setSelectedKazoo(null)
		dispatch(setModalData(null))
	}
	
	const handleSubmit = () => {
		if (selectedKazoo?._id && modalData?.plannerId) {
			dispatch(
				addPlannerToKazoo({
					kazooId: selectedKazoo._id,
					plannerId: modalData.plannerId,
					plannerData: {
						status: 'pending',
						quote: 0,
						notes: '',
					}
				})
			)
			closeAllModals()
		}
	}

	return (
		<>
			<div className={styles.pageWrap}>
				<div className={styles.pageHeader}>
					<Typography component="h1">
						Planners
					</Typography>
				</div>
				<PlannerListComponent />
			</div>

			<CommonModal
				open={modal === 'addFavoritePlannerModal'}
				handleClose={closeAllModals}
				heading="Add to Favorites"
				subHeading="Select Wedding to add planner in favorites"
				footerContent={
					<>
						<ButtonCustom
							onClick={closeAllModals}
							variant="outlined"
							size="lg"
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleSubmit}
						>
							Add
						</ButtonCustom>
					</>
				}
			>
				<WeddingSelect
					setSelectedKazoo={setSelectedKazoo}
					selectedKazoo={selectedKazoo}
					hideDetails={true}
				/>
			</CommonModal>
		</>
	)
}
